import { Group, Badge, Button, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { configApi } from "../api/config.js";
import { useState } from "react";
import { ModeChangeDialog } from "./ModeChangeDialog.js";

export function ModeBanner() {
  const { data, isLoading } = useQuery({ queryKey: ["config"], queryFn: configApi.get, refetchInterval: 30_000 });
  const [open, setOpen] = useState(false);

  if (isLoading || !data) return null;

  const color = data.pipelineMode === "V7_LIVE" ? "green"
              : data.pipelineMode === "V7_SHADOW" ? "yellow"
              : "gray";

  return (
    <Group justify="space-between" px="md" py="xs" bg="gray.1">
      <Group gap="xs">
        <Text fw={500}>Pipeline mode:</Text>
        <Badge color={color} size="lg">{data.pipelineMode}</Badge>
      </Group>
      <Button size="xs" variant="default" onClick={() => setOpen(true)}>Change mode</Button>
      <ModeChangeDialog opened={open} onClose={() => setOpen(false)} currentMode={data.pipelineMode} />
    </Group>
  );
}
